var e=function(e,t){return"undefined"!=typeof grecaptcha&&e?grecaptcha.execute(e,{action:"submit"}).then(t):t()};export{e as default};
